import { Component } from 'preact'

class Hover extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isHovering: false
    }
  }

  render (props, state) {
    return (
      <div className='hoverable'
        onMouseEnter={() => this.setState({ isHovering: true })}
        onMouseLeave={() => this.setState({ isHovering: false })}
      >
        {props.children}
        {state.isHovering ? (props.hoverComponent) : null}
      </div>
    )
  }
}

export default Hover
